<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Return Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/pos/daily/sales">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row dense id="po" class="text--primary subtitle-2">
          <v-col cols="12" xs="12" md="4" sm="4">
            <span>Customer: {{ record.ocrd && record.ocrd.Name}}</span>
          </v-col>

          <v-col cols="12" xs="12" md="4" sm="4">
            <span v-if="record.DocTotal">Total Amount: {{record.DocTotal.toLocaleString()}}</span>
          </v-col>

          <v-col cols="12" xs="12" md="4" sm="4">Date: {{record.DocDate}}</v-col>

          <v-col cols="12" id="docForm">
            <v-data-table
              light
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="returnsData"
              item-key="id"
              hide-default-footer
            >
              <template v-slot:item.product="{ item }">
                <span style="color: red">{{item.product.Name}}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <span style="color: red">{{item.Quantity}}</span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price" style="color: red">{{item.Price.toLocaleString()}}</span>
              </template>

              <template v-slot:item.LineTotal="{ item }">
                <span v-if="item.LineTotal" style="color: red">{{item.LineTotal.toLocaleString()}}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      pageItems: 100,
      returnsData: [],
      headers: [
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
      ],
    };
  },
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/customer-sales-return/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.record = res.ResponseData;
              self.returnsData = res.ResponseData.rows;
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getById();
  },
};
</script>

<style lang="scss" scoped>
</style>